import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { HintTypeEnum } from 'projects/workspace/src/app/hrm/models/hints-list.model';
import { newTransactionsHints } from 'projects/workspace/src/app/warehouse/configs/hints.config';
import { TransactionTypeEnum } from 'projects/workspace/src/app/warehouse/modules/transactions/enums';
import {
  BaseMegaHintComponentDependences,
  BaseMegaHintsComponent
} from '../../../rnpl-common/components/base-mega-hints/base-mega-hints.component';

@Component({
  selector: 'rnpl-new-transactions-hints',
  templateUrl: './new-transactions-hints.component.html',
  styleUrls: ['./new-transactions-hints.component.css']
})
export class NewTransactionsHintsComponent extends BaseMegaHintsComponent implements OnInit, OnChanges {

  @Input() public transactionType: TransactionTypeEnum;
  @Input() public screenName: string;

  constructor(
    public deps: BaseMegaHintComponentDependences
  ) {
    super(deps);
  }

  ngOnInit() {
    this.endFinishText = 'BUTTON.CREATE_TRANSACTION';
    if (this.shepherdService.isActive) {
      this.shepherdService.cancel();
      this.shepherdService.complete();
    }

    this.displayHints();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('transactionType')) {
      clearInterval(this.countdownTimer);
      if (this.shepherdService.isActive) {
        this.shepherdService.complete();
        this.shepherdService.cancel();
        this.animationStateIsPaused$.next(false);
      }

      this.initHints();
    }
  }

  private initHints(): void {
    this.hintsList = [];
    this.notViewedHintsList = [];

    this.hrmService.getHintsByPage(this.screenName)
      .pipe(takeUntil(this._destroy))
      .subscribe(hints => {

        if (!!hints.data.hints && !!hints.data.hints.length) {
          this.hintListByName = newTransactionsHints(this.transactionType);

          this.hintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => !!this.hintListByName[hint.name]);

          this.notViewedHintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => !hint.viewed)
            .filter(hint => !!this.hintListByName[hint.name]);

          this.megaHintId = +hints.data.hints[0].id;

          if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
            this.addHintsSteps(this.notViewedHintsList);
          }

          if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
            this.shepherdService.start();
          }
        }
      });
  }
}
